import React from 'react'

export const TrashIcon = (props) => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V6C13 4.9 12.1 4 11 4H3C1.9 4 1 4.9 1 6V16ZM13 1H10.5L9.79 0.29C9.61 0.11 9.35 0 9.09 0H4.91C4.65 0 4.39 0.11 4.21 0.29L3.5 1H1C0.45 1 0 1.45 0 2C0 2.55 0.45 3 1 3H13C13.55 3 14 2.55 14 2C14 1.45 13.55 1 13 1Z"
      fill="#cfd4d9"
    />
  </svg>
)

export const EditIcon = (props) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 15.4601V18.5001C0 18.7801 0.22 19.0001 0.5 19.0001H3.54C3.67 19.0001 3.8 18.9501 3.89 18.8501L14.81 7.94006L11.06 4.19006L0.15 15.1001C0.0500001 15.2001 0 15.3201 0 15.4601ZM17.71 5.04006C18.1 4.65006 18.1 4.02006 17.71 3.63006L15.37 1.29006C14.98 0.900059 14.35 0.900059 13.96 1.29006L12.13 3.12006L15.88 6.87006L17.71 5.04006Z"
      fill="#cfd4d9"
    />
  </svg>
)

export const PlusIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99996 1.66675C5.39996 1.66675 1.66663 5.40008 1.66663 10.0001C1.66663 14.6001 5.39996 18.3334 9.99996 18.3334C14.6 18.3334 18.3333 14.6001 18.3333 10.0001C18.3333 5.40008 14.6 1.66675 9.99996 1.66675ZM13.3333 10.8334H10.8333V13.3334C10.8333 13.7917 10.4583 14.1667 9.99996 14.1667C9.54163 14.1667 9.16663 13.7917 9.16663 13.3334V10.8334H6.66663C6.20829 10.8334 5.83329 10.4584 5.83329 10.0001C5.83329 9.54175 6.20829 9.16675 6.66663 9.16675H9.16663V6.66675C9.16663 6.20842 9.54163 5.83342 9.99996 5.83342C10.4583 5.83342 10.8333 6.20842 10.8333 6.66675V9.16675H13.3333C13.7916 9.16675 14.1666 9.54175 14.1666 10.0001C14.1666 10.4584 13.7916 10.8334 13.3333 10.8334Z"
      fill="#000092"
    />
  </svg>
)

export const HomeIcon = (props) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.66673 10.6666V7.33331H8.3334V10.6666C8.3334 11.0333 8.6334 11.3333 9.00007 11.3333H11.0001C11.3667 11.3333 11.6667 11.0333 11.6667 10.6666V5.99998H12.8001C13.1067 5.99998 13.2534 5.61998 13.0201 5.41998L7.44673 0.39998C7.1934 0.173314 6.80673 0.173314 6.5534 0.39998L0.980065 5.41998C0.753399 5.61998 0.893399 5.99998 1.20007 5.99998H2.3334V10.6666C2.3334 11.0333 2.6334 11.3333 3.00007 11.3333H5.00007C5.36673 11.3333 5.66673 11.0333 5.66673 10.6666Z"
      fill="#545F7C"
    />
  </svg>
)

export const ArrowIcon = (props) => (
  <svg
    width="6"
    height="8"
    viewBox="0 0 6 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.19329 0.473307C0.933291 0.733307 0.933291 1.15331 1.19329 1.41331L3.77996 3.99997L1.19329 6.58664C0.933291 6.84664 0.933291 7.26664 1.19329 7.52664C1.45329 7.78664 1.87329 7.78664 2.13329 7.52664L5.19329 4.46664C5.45329 4.20664 5.45329 3.78664 5.19329 3.52664L2.13329 0.466641C1.87996 0.213307 1.45329 0.213307 1.19329 0.473307Z"
      fill="#545F7C"
    />
  </svg>
)

export const ReloadIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.16665 5.29171V8.35837C7.16665 8.65004 7.32499 8.92504 7.57499 9.07504L10.175 10.6167C10.475 10.7917 10.8583 10.6917 11.0333 10.4C11.2083 10.1 11.1167 9.71671 10.8167 9.54171L8.42499 8.11671V5.28337C8.41665 4.95004 8.13332 4.66671 7.79165 4.66671C7.44999 4.66671 7.16665 4.95004 7.16665 5.29171ZM15.5 5.91671V1.50837C15.5 1.13337 15.05 0.950039 14.7917 1.21671L13.3083 2.70004C11.8 1.19171 9.64999 0.32504 7.29999 0.533373C3.80832 0.850039 0.933319 3.65837 0.549986 7.15004C0.0499856 11.6667 3.57499 15.5 7.99999 15.5C11.825 15.5 14.9833 12.6334 15.4417 8.93337C15.5 8.43337 15.1083 8.00004 14.6083 8.00004C14.1917 8.00004 13.8417 8.30837 13.7917 8.71671C13.4333 11.625 10.925 13.875 7.91665 13.8334C4.82499 13.7917 2.21665 11.1834 2.16665 8.08337C2.11665 4.83337 4.75832 2.16671 7.99999 2.16671C9.60832 2.16671 11.0667 2.82504 12.125 3.87504L10.3833 5.61671C10.1167 5.88337 10.3 6.33337 10.675 6.33337H15.0833C15.3167 6.33337 15.5 6.15004 15.5 5.91671Z"
      fill="#000092"
    />
  </svg>
)

export const ArrowBottom = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.99997 1V12.17L2.11997 7.29C1.72997 6.9 1.08997 6.9 0.699971 7.29C0.309971 7.68 0.309971 8.31 0.699971 8.7L7.28997 15.29C7.67997 15.68 8.30997 15.68 8.69997 15.29L15.29 8.7C15.68 8.31 15.68 7.68 15.29 7.29C14.9 6.9 14.27 6.9 13.88 7.29L8.99997 12.17V1C8.99997 0.45 8.54997 0 7.99997 0C7.44997 0 6.99997 0.45 6.99997 1Z"
      fill="var(--primaryBright)"
    />
  </svg>
)

export const CompanyIcon = (props) => (
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5 4V2C10.5 0.9 9.6375 0 8.58333 0H2.83333C1.77917 0 0.916666 0.9 0.916666 2V16C0.916666 17.1 1.77917 18 2.83333 18H18.1667C19.2208 18 20.0833 17.1 20.0833 16V6C20.0833 4.9 19.2208 4 18.1667 4H10.5ZM4.75 16H2.83333V14H4.75V16ZM4.75 12H2.83333V10H4.75V12ZM4.75 8H2.83333V6H4.75V8ZM4.75 4H2.83333V2H4.75V4ZM8.58333 16H6.66667V14H8.58333V16ZM8.58333 12H6.66667V10H8.58333V12ZM8.58333 8H6.66667V6H8.58333V8ZM8.58333 4H6.66667V2H8.58333V4ZM17.2083 16H10.5V14H12.4167V12H10.5V10H12.4167V8H10.5V6H17.2083C17.7354 6 18.1667 6.45 18.1667 7V15C18.1667 15.55 17.7354 16 17.2083 16ZM16.25 8H14.3333V10H16.25V8ZM16.25 12H14.3333V14H16.25V12Z"
      fill="black"
    />
  </svg>
)

export const UserIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V15C0 15.55 0.45 16 1 16H15C15.55 16 16 15.55 16 15V14C16 11.34 10.67 10 8 10Z"
      fill="#545F7C"
    />
  </svg>
)

export const AlphabetSort = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5518 15.3092H10.778V2.37394C10.778 2.16747 10.6105 2 10.4041 2H4.63165C4.42518 2 4.25775 2.16747 4.25775 2.37394V15.3092H2.48394C1.96779 15.3092 1.84509 15.6051 2.21017 15.9702L6.85693 20.617C7.22201 20.9821 7.81368 20.9821 8.1788 20.617L12.8255 15.9702C13.1906 15.6051 13.0681 15.3092 12.5518 15.3092Z"
      fill="black"
    />
    <path
      d="M17.9355 10.2168C17.9043 10.139 17.8288 10.0879 17.745 10.0879H16.6518C16.5672 10.0879 16.4913 10.1398 16.4605 10.2186L14.4662 15.339C14.4415 15.4022 14.4497 15.4734 14.4879 15.5292C14.5261 15.5853 14.5895 15.6188 14.6572 15.6188H15.7539C15.8403 15.6188 15.9173 15.5648 15.9468 15.4835L16.3204 14.4555H18.0822L18.4787 15.487C18.5091 15.5662 18.5854 15.6185 18.6702 15.6185H19.7948C19.8629 15.6185 19.9266 15.5847 19.9647 15.5283C20.0029 15.4718 20.0107 15.4002 19.9852 15.337L17.9355 10.2168ZM17.5965 13.1825H16.7877L17.1881 12.0824L17.5965 13.1825Z"
      fill="black"
    />
    <path
      d="M14.941 6.81937V7.75191C14.941 7.86518 15.0329 7.95713 15.1462 7.95713H19.3062C19.4195 7.95713 19.5114 7.86518 19.5114 7.75191V6.88912C19.5114 6.77584 19.4195 6.68389 19.3062 6.68389H16.8241L19.3573 3.564C19.3871 3.52749 19.4033 3.48171 19.4033 3.43473V2.6315C19.4033 2.51822 19.3113 2.42627 19.198 2.42627H15.4502C15.3369 2.42627 15.245 2.51822 15.245 2.6315V3.49778C15.245 3.61105 15.3369 3.703 15.4502 3.703H17.4056L14.9868 6.69029C14.9572 6.72681 14.941 6.77238 14.941 6.81937Z"
      fill="black"
    />
  </svg>
)

export const AlphabetSortDesc = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5518 15.3092H10.778V2.37394C10.778 2.16747 10.6105 2 10.4041 2H4.63165C4.42518 2 4.25775 2.16747 4.25775 2.37394V15.3092H2.48394C1.96779 15.3092 1.84509 15.6051 2.21017 15.9702L6.85693 20.617C7.22201 20.9821 7.81368 20.9821 8.1788 20.617L12.8255 15.9702C13.1906 15.6051 13.0681 15.3092 12.5518 15.3092Z"
      fill="black"
    />
    <path
      d="M17.4834 2.42868C17.4521 2.35091 17.3766 2.2998 17.2929 2.2998H16.1996C16.1151 2.2998 16.0391 2.35172 16.0083 2.43052L14.014 7.55093C13.9894 7.61414 13.9976 7.68536 14.0357 7.74116C14.0739 7.7972 14.1373 7.83067 14.205 7.83067H15.3018C15.3882 7.83067 15.4651 7.77671 15.4947 7.69542L15.8682 6.66745H17.6301L18.0266 7.69891C18.0569 7.77812 18.1333 7.83046 18.218 7.83046H19.3427C19.4108 7.83046 19.4744 7.79659 19.5126 7.74019C19.5508 7.68375 19.5585 7.61216 19.5331 7.54891L17.4834 2.42868ZM17.1443 5.3944H16.3355L16.7359 4.29436L17.1443 5.3944Z"
      fill="black"
    />
    <path
      d="M14.941 14.3931V15.3256C14.941 15.4389 15.0329 15.5309 15.1462 15.5309H19.3062C19.4195 15.5309 19.5114 15.4389 19.5114 15.3256V14.4628C19.5114 14.3496 19.4195 14.2576 19.3062 14.2576H16.8241L19.3573 11.1377C19.3871 11.1012 19.4033 11.0554 19.4033 11.0085V10.2052C19.4033 10.0919 19.3113 10 19.198 10H15.4502C15.3369 10 15.245 10.0919 15.245 10.2052V11.0715C15.245 11.1848 15.3369 11.2767 15.4502 11.2767H17.4056L14.9868 14.264C14.9572 14.3005 14.941 14.3461 14.941 14.3931Z"
      fill="black"
    />
  </svg>
)

export const UsersSort = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.1129 10.6768H15.5662C15.7238 11.1084 15.81 11.5742 15.81 12.0597V17.9054C15.81 18.1079 15.7747 18.3022 15.7106 18.4829H18.2677C19.2229 18.4829 20 17.7058 20 16.7506V13.5638C20 11.9719 18.7048 10.6768 17.1129 10.6768Z"
      fill="black"
    />
    <path
      d="M4.19005 12.0597C4.19005 11.5742 4.27618 11.1084 4.43384 10.6768H2.88712C1.29516 10.6768 0 11.9719 0 13.5639V16.7506C0 17.7058 0.777072 18.4829 1.73227 18.4829H4.28938C4.22528 18.3021 4.19005 18.1079 4.19005 17.9054V12.0597Z"
      fill="black"
    />
    <path
      d="M11.768 9.17236H8.23196C6.64001 9.17236 5.34485 10.4675 5.34485 12.0595V17.9052C5.34485 18.2241 5.60336 18.4826 5.92227 18.4826H14.0777C14.3966 18.4826 14.6551 18.2241 14.6551 17.9052V12.0595C14.6551 10.4675 13.3599 9.17236 11.768 9.17236Z"
      fill="black"
    />
    <path
      d="M10.0001 1.51709C8.08554 1.51709 6.52795 3.07467 6.52795 4.98925C6.52795 6.28788 7.24471 7.42207 8.30323 8.01754C8.8053 8.29996 9.38413 8.46137 10.0001 8.46137C10.616 8.46137 11.1948 8.29996 11.6969 8.01754C12.7555 7.42207 13.4722 6.28784 13.4722 4.98925C13.4722 3.07471 11.9146 1.51709 10.0001 1.51709Z"
      fill="black"
    />
    <path
      d="M3.90308 4.75342C2.47124 4.75342 1.3064 5.91827 1.3064 7.35011C1.3064 8.78195 2.47124 9.9468 3.90308 9.9468C4.26628 9.9468 4.61214 9.87156 4.92632 9.73633C5.46952 9.50246 5.91741 9.08847 6.19456 8.56992C6.38909 8.20597 6.49976 7.79077 6.49976 7.35011C6.49976 5.9183 5.33491 4.75342 3.90308 4.75342Z"
      fill="black"
    />
    <path
      d="M16.0969 4.75342C14.6651 4.75342 13.5002 5.91827 13.5002 7.35011C13.5002 7.79081 13.6109 8.20601 13.8054 8.56992C14.0826 9.08851 14.5305 9.5025 15.0737 9.73633C15.3879 9.87156 15.7337 9.9468 16.0969 9.9468C17.5288 9.9468 18.6936 8.78195 18.6936 7.35011C18.6936 5.91827 17.5288 4.75342 16.0969 4.75342Z"
      fill="black"
    />
  </svg>
)

export const CompaniesSort = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.625 1.25H3.125C2.62772 1.25 2.15081 1.44754 1.79917 1.79917C1.44754 2.15081 1.25 2.62772 1.25 3.125V18.125C1.25 18.2908 1.31585 18.4497 1.43306 18.5669C1.55027 18.6842 1.70924 18.75 1.875 18.75H5V14.375C5 14.2092 5.06585 14.0503 5.18306 13.9331C5.30027 13.8158 5.45924 13.75 5.625 13.75H8.125C8.29076 13.75 8.44973 13.8158 8.56694 13.9331C8.68415 14.0503 8.75 14.2092 8.75 14.375V18.75H12.5V3.125C12.5 2.62772 12.3025 2.15081 11.9508 1.79917C11.5992 1.44754 11.1223 1.25 10.625 1.25ZM5.625 11.875H4.375C4.20924 11.875 4.05027 11.8092 3.93306 11.6919C3.81585 11.5747 3.75 11.4158 3.75 11.25C3.75 11.0842 3.81585 10.9253 3.93306 10.8081C4.05027 10.6908 4.20924 10.625 4.375 10.625H5.625C5.79076 10.625 5.94973 10.6908 6.06694 10.8081C6.18415 10.9253 6.25 11.0842 6.25 11.25C6.25 11.4158 6.18415 11.5747 6.06694 11.6919C5.94973 11.8092 5.79076 11.875 5.625 11.875ZM5.625 8.75H4.375C4.20924 8.75 4.05027 8.68415 3.93306 8.56694C3.81585 8.44973 3.75 8.29076 3.75 8.125C3.75 7.95924 3.81585 7.80027 3.93306 7.68306C4.05027 7.56585 4.20924 7.5 4.375 7.5H5.625C5.79076 7.5 5.94973 7.56585 6.06694 7.68306C6.18415 7.80027 6.25 7.95924 6.25 8.125C6.25 8.29076 6.18415 8.44973 6.06694 8.56694C5.94973 8.68415 5.79076 8.75 5.625 8.75ZM5.625 5.625H4.375C4.20924 5.625 4.05027 5.55915 3.93306 5.44194C3.81585 5.32473 3.75 5.16576 3.75 5C3.75 4.83424 3.81585 4.67527 3.93306 4.55806C4.05027 4.44085 4.20924 4.375 4.375 4.375H5.625C5.79076 4.375 5.94973 4.44085 6.06694 4.55806C6.18415 4.67527 6.25 4.83424 6.25 5C6.25 5.16576 6.18415 5.32473 6.06694 5.44194C5.94973 5.55915 5.79076 5.625 5.625 5.625ZM9.375 11.875H8.125C7.95924 11.875 7.80027 11.8092 7.68306 11.6919C7.56585 11.5747 7.5 11.4158 7.5 11.25C7.5 11.0842 7.56585 10.9253 7.68306 10.8081C7.80027 10.6908 7.95924 10.625 8.125 10.625H9.375C9.54076 10.625 9.69973 10.6908 9.81694 10.8081C9.93415 10.9253 10 11.0842 10 11.25C10 11.4158 9.93415 11.5747 9.81694 11.6919C9.69973 11.8092 9.54076 11.875 9.375 11.875ZM9.375 8.75H8.125C7.95924 8.75 7.80027 8.68415 7.68306 8.56694C7.56585 8.44973 7.5 8.29076 7.5 8.125C7.5 7.95924 7.56585 7.80027 7.68306 7.68306C7.80027 7.56585 7.95924 7.5 8.125 7.5H9.375C9.54076 7.5 9.69973 7.56585 9.81694 7.68306C9.93415 7.80027 10 7.95924 10 8.125C10 8.29076 9.93415 8.44973 9.81694 8.56694C9.69973 8.68415 9.54076 8.75 9.375 8.75ZM9.375 5.625H8.125C7.95924 5.625 7.80027 5.55915 7.68306 5.44194C7.56585 5.32473 7.5 5.16576 7.5 5C7.5 4.83424 7.56585 4.67527 7.68306 4.55806C7.80027 4.44085 7.95924 4.375 8.125 4.375H9.375C9.54076 4.375 9.69973 4.44085 9.81694 4.55806C9.93415 4.67527 10 4.83424 10 5C10 5.16576 9.93415 5.32473 9.81694 5.44194C9.69973 5.55915 9.54076 5.625 9.375 5.625Z"
      fill="black"
    />
    <path
      d="M16.875 4.375H13.75V7.5H15.625C15.7908 7.5 15.9497 7.56585 16.0669 7.68306C16.1842 7.80027 16.25 7.95924 16.25 8.125C16.25 8.29076 16.1842 8.44973 16.0669 8.56694C15.9497 8.68415 15.7908 8.75 15.625 8.75H13.75V10.625H15.625C15.7908 10.625 15.9497 10.6908 16.0669 10.8081C16.1842 10.9253 16.25 11.0842 16.25 11.25C16.25 11.4158 16.1842 11.5747 16.0669 11.6919C15.9497 11.8092 15.7908 11.875 15.625 11.875H13.75V13.75H15.625C15.7908 13.75 15.9497 13.8158 16.0669 13.9331C16.1842 14.0503 16.25 14.2092 16.25 14.375C16.25 14.5408 16.1842 14.6997 16.0669 14.8169C15.9497 14.9342 15.7908 15 15.625 15H13.75V18.75H18.125C18.2908 18.75 18.4497 18.6842 18.5669 18.5669C18.6842 18.4497 18.75 18.2908 18.75 18.125V6.25C18.75 5.75272 18.5525 5.27581 18.2008 4.92417C17.8492 4.57254 17.3723 4.375 16.875 4.375Z"
      fill="black"
    />
  </svg>
)

export const DisableIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 0C4.48607 0 0 4.48607 0 10C0 15.5139 4.48607 20 10 20C15.5139 20 20 15.5139 20 10C20 4.48607 15.5139 0 10 0ZM2.49998 10C2.49998 8.38272 3.01969 6.88744 3.89358 5.66115L14.3388 16.1064C13.1125 16.9802 11.6172 17.5 9.99996 17.5C5.86427 17.5 2.49998 14.1357 2.49998 10ZM16.1064 14.3389L5.66111 3.89358C6.8874 3.01973 8.38268 2.49998 9.99996 2.49998C14.1357 2.49998 17.4999 5.86423 17.4999 9.99996C17.4999 11.6173 16.9802 13.1126 16.1064 14.3389Z"
      fill="#545F7C"
    />
  </svg>
)

export const DisableUser = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.2272 18.6665C9.3903 17.6351 8.88887 16.3205 8.88887 14.8888C8.88887 13.2555 9.5415 11.7746 10.6003 10.6926C7.26202 10.3061 3.83432 10.9239 0.782019 12.5459C0.300791 12.8017 0 13.3021 0 13.8471V17.1109C0 17.97 0.696445 18.6665 1.55556 18.6665H10.2272H10.2272Z"
      fill="#000062"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.66667 0C6.08934 0 4 2.08934 4 4.66667C4 7.24401 6.08934 9.33335 8.66667 9.33335C11.244 9.33335 13.3333 7.24401 13.3333 4.66667C13.3333 2.08934 11.244 0 8.66667 0Z"
      fill="#000062"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8889 11.1112C12.8025 11.1112 11.1112 12.8025 11.1112 14.8889C11.1112 16.9754 12.8025 18.6667 14.8889 18.6667C16.9754 18.6667 18.6667 16.9754 18.6667 14.8889C18.6667 12.8025 16.9754 11.1112 14.8889 11.1112ZM9.77783 14.8889C9.77783 12.0662 12.0662 9.77783 14.8889 9.77783C17.7117 9.77783 20.0001 12.0662 20.0001 14.8889C20.0001 17.7117 17.7117 20.0001 14.8889 20.0001C12.0662 20.0001 9.77783 17.7117 9.77783 14.8889Z"
      fill="#000062"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4713 11.3064C18.211 11.046 17.7889 11.046 17.5286 11.3064L11.3064 17.5286C11.046 17.7889 11.046 18.211 11.3064 18.4713C11.5667 18.7317 11.9888 18.7317 12.2491 18.4713L18.4713 12.2491C18.7317 11.9888 18.7317 11.5667 18.4713 11.3064Z"
      fill="#000062"
    />
  </svg>
)

export const OrderIcon = (props) => (
  <svg
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.510039 1.71L3.10004 4.3C3.49004 4.69 4.12004 4.69 4.51004 4.3L7.10004 1.71C7.73004 1.08 7.28004 0 6.39004 0H1.21004C0.320039 0 -0.119961 1.08 0.510039 1.71Z"
      fill="black"
    />
  </svg>
)

export const ListView = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 10H2C0.9 10 0 10.9 0 12V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V12C18 10.9 17.1 10 16 10Z"
      fill="#545F7C"
    />
    <path
      d="M16 0H2C0.9 0 0 0.9 0 2V6C0 7.1 0.9 8 2 8H16C17.1 8 18 7.1 18 6V2C18 0.9 17.1 0 16 0Z"
      fill="#545F7C"
    />
  </svg>
)

export const CardView = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 8H6C7.1 8 8 7.1 8 6V2C8 0.9 7.1 0 6 0H2C0.9 0 0 0.9 0 2V6C0 7.1 0.9 8 2 8Z"
      fill="#545F7C"
    />
    <path
      d="M2 18H6C7.1 18 8 17.1 8 16V12C8 10.9 7.1 10 6 10H2C0.9 10 0 10.9 0 12V16C0 17.1 0.9 18 2 18Z"
      fill="#545F7C"
    />
    <path
      d="M10 2V6C10 7.1 10.9 8 12 8H16C17.1 8 18 7.1 18 6V2C18 0.9 17.1 0 16 0H12C10.9 0 10 0.9 10 2Z"
      fill="#545F7C"
    />
    <path
      d="M12 18H16C17.1 18 18 17.1 18 16V12C18 10.9 17.1 10 16 10H12C10.9 10 10 10.9 10 12V16C10 17.1 10.9 18 12 18Z"
      fill="#545F7C"
    />
  </svg>
)

export const SettingsIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.2502 9.00001C15.2502 8.80834 15.2419 8.62501 15.2252 8.43334L16.7752 7.25834C17.1085 7.00834 17.2002 6.54167 16.9919 6.17501L15.4335 3.48334C15.2252 3.11667 14.7752 2.96667 14.3919 3.13334L12.6002 3.89167C12.2919 3.67501 11.9669 3.48334 11.6252 3.32501L11.3835 1.40001C11.3335 0.983339 10.9752 0.666672 10.5585 0.666672H7.45021C7.02521 0.666672 6.66688 0.983339 6.61688 1.40001L6.37521 3.32501C6.03354 3.48334 5.70854 3.67501 5.40021 3.89167L3.60854 3.13334C3.22521 2.96667 2.77521 3.11667 2.56688 3.48334L1.00854 6.18334C0.800209 6.55001 0.891876 7.00834 1.22521 7.26667L2.77521 8.44167C2.75854 8.62501 2.75021 8.80834 2.75021 9.00001C2.75021 9.19167 2.75854 9.37501 2.77521 9.56667L1.22521 10.7417C0.891876 10.9917 0.800209 11.4583 1.00854 11.825L2.56688 14.5167C2.77521 14.8833 3.22521 15.0333 3.60854 14.8667L5.40021 14.1083C5.70854 14.325 6.03354 14.5167 6.37521 14.675L6.61688 16.6C6.66688 17.0167 7.02521 17.3333 7.44188 17.3333H10.5502C10.9669 17.3333 11.3252 17.0167 11.3752 16.6L11.6169 14.675C11.9585 14.5167 12.2835 14.325 12.5919 14.1083L14.3835 14.8667C14.7669 15.0333 15.2169 14.8833 15.4252 14.5167L16.9835 11.825C17.1919 11.4583 17.1002 11 16.7669 10.7417L15.2169 9.56667C15.2419 9.37501 15.2502 9.19167 15.2502 9.00001ZM9.03354 11.9167C7.42521 11.9167 6.11688 10.6083 6.11688 9.00001C6.11688 7.39167 7.42521 6.08334 9.03354 6.08334C10.6419 6.08334 11.9502 7.39167 11.9502 9.00001C11.9502 10.6083 10.6419 11.9167 9.03354 11.9167Z"
      fill="#000092"
    />
  </svg>
)

export const InfoIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.1665 4.83334H9.83317V6.50001H8.1665V4.83334ZM8.1665 8.16667H9.83317V13.1667H8.1665V8.16667ZM8.99984 0.666672C4.39984 0.666672 0.666504 4.40001 0.666504 9.00001C0.666504 13.6 4.39984 17.3333 8.99984 17.3333C13.5998 17.3333 17.3332 13.6 17.3332 9.00001C17.3332 4.40001 13.5998 0.666672 8.99984 0.666672ZM8.99984 15.6667C5.32484 15.6667 2.33317 12.675 2.33317 9.00001C2.33317 5.32501 5.32484 2.33334 8.99984 2.33334C12.6748 2.33334 15.6665 5.32501 15.6665 9.00001C15.6665 12.675 12.6748 15.6667 8.99984 15.6667Z"
      fill="#545F7C"
    />
  </svg>
)

export const CrossIcon = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.4999 0.516679C20.8499 -0.133321 19.7999 -0.133321 19.15 0.516679L11 8.65001L2.84995 0.500012C2.19995 -0.149988 1.14995 -0.149988 0.499951 0.500012C-0.150049 1.15001 -0.150049 2.20001 0.499951 2.85001L8.64995 11L0.499951 19.15C-0.150049 19.8 -0.150049 20.85 0.499951 21.5C1.14995 22.15 2.19995 22.15 2.84995 21.5L11 13.35L19.15 21.5C19.7999 22.15 20.8499 22.15 21.4999 21.5C22.1499 20.85 22.1499 19.8 21.4999 19.15L13.3499 11L21.4999 2.85001C22.1333 2.21668 22.1333 1.15001 21.4999 0.516679Z"
      fill="#CFD4D9"
    />
  </svg>
)

export const DraftIcon = (props) => (
  <svg
    width="19"
    height="21"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.333 2H11.153C10.733 0.84 9.63301 0 8.33301 0C7.03301 0 5.93301 0.84 5.51301 2H2.33301C1.23301 2 0.333008 2.9 0.333008 4V19C0.333008 20.1 1.23301 21 2.33301 21H8.44301C7.85301 20.43 7.37301 19.75 7.02301 19H2.33301V4H4.33301V5C4.33301 6.1 5.23301 7 6.33301 7H10.333C11.433 7 12.333 6.1 12.333 5V4H14.333V9.08C15.043 9.18 15.713 9.39 16.333 9.68V4C16.333 2.9 15.433 2 14.333 2ZM8.33301 4C7.78301 4 7.33301 3.55 7.33301 3C7.33301 2.45 7.78301 2 8.33301 2C8.88301 2 9.33301 2.45 9.33301 3C9.33301 3.55 8.88301 4 8.33301 4ZM13.333 11C10.573 11 8.33301 13.24 8.33301 16C8.33301 18.76 10.573 21 13.333 21C16.093 21 18.333 18.76 18.333 16C18.333 13.24 16.093 11 13.333 11ZM14.623 18L12.973 16.35C12.883 16.26 12.823 16.13 12.823 16V13.51C12.823 13.23 13.043 13.01 13.323 13.01C13.603 13.01 13.823 13.23 13.823 13.51V15.8L15.323 17.3C15.523 17.5 15.523 17.81 15.323 18.01C15.133 18.2 14.823 18.2 14.623 18Z"
      fill="#000092"
    />
  </svg>
)

export const CheckIcon = (props) => (
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.33266 10.17L1.86266 6.70001C1.47266 6.31001 0.842656 6.31001 0.452656 6.70001C0.0626563 7.09001 0.0626563 7.72001 0.452656 8.11001L4.63266 12.29C5.02266 12.68 5.65266 12.68 6.04266 12.29L16.6227 1.71001C17.0127 1.32001 17.0127 0.690007 16.6227 0.300007C16.2327 -0.0899927 15.6027 -0.0899927 15.2127 0.300007L5.33266 10.17Z"
      fill="#545F7C"
    />
  </svg>
)

export const RefreshIcon = (props) => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.00004 3.99999V5.49166C7.00004 5.86666 7.45004 6.04999 7.70837 5.78332L10.0334 3.45832C10.2 3.29166 10.2 3.03332 10.0334 2.86666L7.70837 0.541658C7.45004 0.283325 7.00004 0.466658 7.00004 0.841658V2.33332C3.31671 2.33332 0.333374 5.31666 0.333374 8.99999C0.333374 9.86666 0.500041 10.7 0.808374 11.4583C1.03337 12.0167 1.75004 12.1667 2.17504 11.7417C2.40004 11.5167 2.49171 11.175 2.36671 10.875C2.12504 10.3 2.00004 9.65832 2.00004 8.99999C2.00004 6.24166 4.24171 3.99999 7.00004 3.99999ZM11.825 6.25832C11.6 6.48332 11.5084 6.83332 11.6334 7.12499C11.8667 7.70832 12 8.34166 12 8.99999C12 11.7583 9.75837 14 7.00004 14V12.5083C7.00004 12.1333 6.55004 11.95 6.29171 12.2167L3.96671 14.5417C3.80004 14.7083 3.80004 14.9667 3.96671 15.1333L6.29171 17.4583C6.55004 17.7167 7.00004 17.5333 7.00004 17.1667V15.6667C10.6834 15.6667 13.6667 12.6833 13.6667 8.99999C13.6667 8.13332 13.5 7.29999 13.1917 6.54166C12.9667 5.98332 12.25 5.83332 11.825 6.25832Z"
      fill="#000092"
    />
  </svg>
)

export const CheckIconWithBorder = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM7.29 14.29L3.7 10.7C3.31 10.31 3.31 9.68 3.7 9.29C4.09 8.9 4.72 8.9 5.11 9.29L8 12.17L14.88 5.29C15.27 4.9 15.9 4.9 16.29 5.29C16.68 5.68 16.68 6.31 16.29 6.7L8.7 14.29C8.32 14.68 7.68 14.68 7.29 14.29Z"
      fill="#000092"
    />
  </svg>
)

export const DrowIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.7083 6.65833L14.5917 5.775C15.2417 5.125 15.2417 4.06667 14.5917 3.41667L13.4167 2.24167C12.7667 1.59167 11.7083 1.59167 11.0583 2.24167L10.175 3.125L13.7083 6.65833ZM8.99167 4.3L1.45 11.8417C1.375 11.9167 1.33333 12.025 1.33333 12.1333V15.0833C1.33333 15.3167 1.51667 15.5 1.75 15.5H4.7C4.80833 15.5 4.91667 15.4583 4.99167 15.375L12.5333 7.83333L8.99167 4.3ZM13.8333 12.5833C13.8333 14.4083 11.7167 15.5 9.66667 15.5C9.20833 15.5 8.83333 15.125 8.83333 14.6667C8.83333 14.2083 9.20833 13.8333 9.66667 13.8333C10.95 13.8333 12.1667 13.225 12.1667 12.5833C12.1667 12.1917 11.7667 11.8583 11.1417 11.5833L12.375 10.35C13.2667 10.875 13.8333 11.575 13.8333 12.5833ZM1.81667 9.125C1.00833 8.65833 0.5 8.05 0.5 7.16667C0.5 5.66667 2.075 4.975 3.46667 4.36667C4.325 3.98333 5.5 3.46667 5.5 3C5.5 2.65833 4.85 2.16667 3.83333 2.16667C2.78333 2.16667 2.33333 2.675 2.30833 2.7C2.01667 3.04167 1.49167 3.08333 1.14167 2.8C0.8 2.51667 0.733333 2.00833 1.01667 1.65C1.10833 1.53333 1.96667 0.5 3.83333 0.5C5.7 0.5 7.16667 1.6 7.16667 3C7.16667 4.55833 5.55833 5.26667 4.13333 5.89167C3.35 6.23333 2.16667 6.75 2.16667 7.16667C2.16667 7.425 2.525 7.66667 3.05833 7.88333L1.81667 9.125Z"
      fill="white"
    />
  </svg>
)

export const CropIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.1667 12.5H15.8334V5.83334C15.8334 4.91668 15.0834 4.16668 14.1667 4.16668H7.50004V5.83334H13.3334C13.7917 5.83334 14.1667 6.20834 14.1667 6.66668V12.5ZM6.66671 14.1667C6.20837 14.1667 5.83337 13.7917 5.83337 13.3333V1.66668C5.83337 1.20834 5.45837 0.833344 5.00004 0.833344C4.54171 0.833344 4.16671 1.20834 4.16671 1.66668V4.16668H1.66671C1.20837 4.16668 0.833374 4.54168 0.833374 5.00001C0.833374 5.45834 1.20837 5.83334 1.66671 5.83334H4.16671V14.1667C4.16671 15.0833 4.91671 15.8333 5.83337 15.8333H14.1667V18.3333C14.1667 18.7917 14.5417 19.1667 15 19.1667C15.4584 19.1667 15.8334 18.7917 15.8334 18.3333V15.8333H18.3334C18.7917 15.8333 19.1667 15.4583 19.1667 15C19.1667 14.5417 18.7917 14.1667 18.3334 14.1667H6.66671Z"
      fill="white"
    />
  </svg>
)

export const FileIcon = (props) => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.9425 0.9425C7.6575 0.6575 7.275 0.5 6.8775 0.5L1.5 0.5C0.675 0.5 0 1.175 0 2L0 14C0 14.825 0.6675 15.5 1.4925 15.5H10.5C11.325 15.5 12 14.825 12 14V5.6225C12 5.225 11.8425 4.8425 11.5575 4.565L7.9425 0.9425ZM8.25 12.5H3.75C3.3375 12.5 3 12.1625 3 11.75C3 11.3375 3.3375 11 3.75 11H8.25C8.6625 11 9 11.3375 9 11.75C9 12.1625 8.6625 12.5 8.25 12.5ZM8.25 9.5H3.75C3.3375 9.5 3 9.1625 3 8.75C3 8.3375 3.3375 8 3.75 8H8.25C8.6625 8 9 8.3375 9 8.75C9 9.1625 8.6625 9.5 8.25 9.5ZM6.75 5V1.625L10.875 5.75H7.5C7.0875 5.75 6.75 5.4125 6.75 5Z"
      fill="#000092"
    />
  </svg>
)

export const LockOpen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#000092"
    {...props}
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M12 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6-5h-1V6c0-2.76-2.24-5-5-5-2.28 0-4.27 1.54-4.84 3.75-.14.54.18 1.08.72 1.22.53.14 1.08-.18 1.22-.72C9.44 3.93 10.63 3 12 3c1.65 0 3 1.35 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 11c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v8z" />
  </svg>
)

export const Lock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#000092"
    {...props}
  >
    <g fill="none">
      <path d="M0 0h24v24H0V0z" />
      <path d="M0 0h24v24H0V0z" opacity=".87" />
    </g>
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9z" />
  </svg>
)

export const Comment = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM7 9H17C17.55 9 18 9.45 18 10C18 10.55 17.55 11 17 11H7C6.45 11 6 10.55 6 10C6 9.45 6.45 9 7 9ZM13 14H7C6.45 14 6 13.55 6 13C6 12.45 6.45 12 7 12H13C13.55 12 14 12.45 14 13C14 13.55 13.55 14 13 14ZM17 8H7C6.45 8 6 7.55 6 7C6 6.45 6.45 6 7 6H17C17.55 6 18 6.45 18 7C18 7.55 17.55 8 17 8Z"
      fill="#CFD4D9"
    />
  </svg>
)

export const Certificate = (props) => (
  <svg
    width="16"
    height="21"
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.92 10.75L8 9.93L9.07 10.74C9.46 11.03 9.99 10.66 9.85 10.19L9.43 8.83L10.63 7.88C11 7.6 10.79 7 10.31 7H8.91L8.48 5.66C8.33 5.2 7.68 5.2 7.53 5.66L7.09 7H5.68C5.21 7 5 7.6 5.37 7.89L6.56 8.84L6.14 10.2C6 10.67 6.53 11.04 6.92 10.75ZM2 19.61C2 20.29 2.67 20.77 3.32 20.56L8 19L12.68 20.56C13.33 20.78 14 20.3 14 19.61V13.28C15.24 11.87 16 10.03 16 8C16 3.58 12.42 0 8 0C3.58 0 0 3.58 0 8C0 10.03 0.76 11.87 2 13.28L2 19.61ZM8 2C11.31 2 14 4.69 14 8C14 11.31 11.31 14 8 14C4.69 14 2 11.31 2 8C2 4.69 4.69 2 8 2Z"
      fill="#545F7C"
    />
  </svg>
)

export const File = (props) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.59 0.59C10.21 0.21 9.7 0 9.17 0L2 0C0.9 0 0 0.9 0 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6.83C16 6.3 15.79 5.79 15.41 5.42L10.59 0.59ZM11 16H5C4.45 16 4 15.55 4 15C4 14.45 4.45 14 5 14H11C11.55 14 12 14.45 12 15C12 15.55 11.55 16 11 16ZM11 12H5C4.45 12 4 11.55 4 11C4 10.45 4.45 10 5 10H11C11.55 10 12 10.45 12 11C12 11.55 11.55 12 11 12ZM9 6V1.5L14.5 7H10C9.45 7 9 6.55 9 6Z"
      fill="#545F7C"
    />
  </svg>
)

export const DotIcon = (props) => (
  <svg height="12" width="12" {...props}>
    <circle cx="6" cy="6" r="4" fill="#F6C344" />
  </svg>
)

export const Cancel = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM14.3 14.3C13.91 14.69 13.28 14.69 12.89 14.3L10 11.41L7.11 14.3C6.72 14.69 6.09 14.69 5.7 14.3C5.31 13.91 5.31 13.28 5.7 12.89L8.59 10L5.7 7.11C5.31 6.72 5.31 6.09 5.7 5.7C6.09 5.31 6.72 5.31 7.11 5.7L10 8.59L12.89 5.7C13.28 5.31 13.91 5.31 14.3 5.7C14.69 6.09 14.69 6.72 14.3 7.11L11.41 10L14.3 12.89C14.68 13.27 14.68 13.91 14.3 14.3Z"
      fill="#000092"
    />
  </svg>
)

export const ChevronLeft = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.71 6.70998C14.32 6.31998 13.69 6.31998 13.3 6.70998L8.70998 11.3C8.31998 11.69 8.31998 12.32 8.70998 12.71L13.3 17.3C13.69 17.69 14.32 17.69 14.71 17.3C15.1 16.91 15.1 16.28 14.71 15.89L10.83 12L14.71 8.11998C15.1 7.72998 15.09 7.08998 14.71 6.70998Z"
      fill="black"
    />
  </svg>
)

export const ChevronRight = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.29006 6.71002C8.90006 7.10002 8.90006 7.73002 9.29006 8.12002L13.1701 12L9.29006 15.88C8.90006 16.27 8.90006 16.9 9.29006 17.29C9.68006 17.68 10.3101 17.68 10.7001 17.29L15.2901 12.7C15.6801 12.31 15.6801 11.68 15.2901 11.29L10.7001 6.70002C10.3201 6.32002 9.68006 6.32002 9.29006 6.71002Z"
      fill="black"
    />
  </svg>
)
